// extracted by mini-css-extract-plugin
module.exports = {"author-avatar":"author-m__author-avatar__1Ccld"};